import { render, staticRenderFns } from "./Campaign2024.vue?vue&type=template&id=09857d72&"
import script from "./Campaign2024.vue?vue&type=script&lang=js&"
export * from "./Campaign2024.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports